type FeedbackResponse = {
  ok?: boolean
  error?: string
}

export function initFeedbackForm(): void {
  const form = document.querySelector<HTMLFormElement>('#feedback-form')
  const submit = document.querySelector<HTMLButtonElement>('#feedback-submit')
  const submitText = document.querySelector<HTMLElement>('.feedback-submit-text')
  const submitLoading = document.querySelector<HTMLElement>('.feedback-submit-loading')
  const error = document.querySelector<HTMLElement>('.feedback-error')
  const errorMessage = error?.querySelector<HTMLParagraphElement>('p')
  const success = document.querySelector<HTMLElement>('.feedback-success')
  const sysinfo = document.querySelector<HTMLInputElement>('#feedback-sysinfo')
  if (!form || !submit || !submitText || !submitLoading || !error || !errorMessage || !success || !sysinfo) return

  const deviceMemory = 'deviceMemory' in navigator
    ? `${(navigator as Navigator & { deviceMemory?: number }).deviceMemory ?? '?'}GB`
    : '?GB'
  sysinfo.value = `${navigator.userAgent}, ${deviceMemory}`

  const setSubmitting = (submitting: boolean): void => {
    submit.disabled = submitting
    submitText.classList.toggle('d-none', submitting)
    submitLoading.classList.toggle('d-none', !submitting)
  }

  const showError = (message: string): void => {
    errorMessage.textContent = message
    error.classList.remove('d-none')
  }

  form.addEventListener('submit', async event => {
    event.preventDefault()
    error.classList.add('d-none')
    if (!form.reportValidity()) return

    const values = new FormData(form)
    setSubmitting(true)

    try {
      const response = await fetch('/api/feedback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: values.get('name'),
          email: values.get('email'),
          message: values.get('message'),
          sysinfo: values.get('sysinfo'),
          website: values.get('website'),
        }),
      })
      const data = await response.json().catch(() => ({})) as FeedbackResponse
      if (!response.ok || !data.ok) throw new Error(data.error || 'server_error')

      form.classList.add('d-none')
      success.classList.remove('d-none')
    } catch (caught) {
      const message = caught instanceof Error && caught.message === 'invalid_email'
        ? 'Please enter a valid email address.'
        : 'Something went wrong. Please try again.'
      showError(message)
      setSubmitting(false)
    }
  })
}
